export enum ShippingServiceType {
  PickupToPickup = 'PickupToPickup',
  PickupToCurier = 'PickupToCurier',
  CurierToPickup = 'CurierToPickup',
  CurierToCurier = 'CurierToCurier',
}
